export enum StorageKey {
    TOKEN = 'galil-invoice-token',
    NAME = 'galil-invoice-name'
}
